export function isGroupArchived(group) {
  return group?.status === "archived";
}

export function getActiveGroups(groups) {
  return (groups || []).filter((group) => !isGroupArchived(group));
}

export function getDefaultGroupId(groups) {
  const active = getActiveGroups(groups);
  if (!active.length) return "";

  const generalGroup = active.find(
    (group) => String(group.name || group.raw?.title || "").trim().toLowerCase() === "general",
  );

  return (generalGroup || active[active.length - 1]).id;
}
